// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import CSS
import "../css/index.css";

// Import JS
import weekGroups from "./weekGroups";
import infiniteScroll from "./infiniteScroll";
import baselineGrid from "./baselineGrid";
import readMore from "./readMore";


// Group posts into calendar-week wrappers first, then wire infinite scroll.
weekGroups();
infiniteScroll();
baselineGrid(); // keep media in ruled-paper articles on the baseline grid
readMore();     // reveal "Read more" on text feed cards whose content overflows
